module.exports = __webpack_public_path__ + "static/media/CeraPro-Regular.cf954f65.ttf";